import * as React from 'react';
import { useLoadNativeAd } from '../hooks/native';
import {
    NativeAdObj,
    Status,
    DeviceType,
    Vertical,
    Subvertical,
    PageType,
    Features,
} from '../../shared/types/ast';
import { Content, NativeVideo, Netboard } from '.';
import { getDeviceType } from '../utils/device';

export type Props = {
    adObj: NativeAdObj;
    status: Status;
    id: string;
    className?: string;
    grid: boolean;
    tempRecircHack?: boolean;
    vertical?: Vertical;
    subvertical?: Subvertical;
    pageType?: PageType;
    deviceType: DeviceType;
    features?: Features;
};

export function getNativeType(adObj: NativeAdObj) {
    if (adObj.native) {
        if (adObj.native.video && adObj.native.video.content) {
            return 'video';
        }
        if (adObj.native.desc2) {
            return adObj.native.desc2;
        }
        if (adObj.native.custom) {
            return adObj.native.custom.type;
        }
    }
    return '';
}

export function Native(props: Props) {
    const {
        adObj,
        id,
        className,
        status,
        vertical,
        subvertical,
        pageType,
        deviceType,
        grid,
    } = props;
    useLoadNativeAd(adObj, status);
    const type = getNativeType(adObj);

    let defaultClassName = 'ads__unit ads__unit--native';

    switch (type) {
        case 'content':
            const list = !grid && deviceType !== 'mobile';
            defaultClassName =
                'ads__unit ads__unit--native ads__unit--fullwidth';
            if (list) {
                defaultClassName =
                    'ads__unit ads__unit--native ads__unit--fullwidth p-0';
            }
            if (subvertical === 'holiday_rental') {
                defaultClassName =
                    'ads__unit ads__unit--native ads__unit--fullwidth p-0 pb-16';
            }
            return (
                <div
                    id={id}
                    className={className || defaultClassName}
                    style={{ display: 'block' }}
                >
                    <Content adObj={adObj} list={list} />
                </div>
            );
        case 'video':
            return (
                <div
                    id={id}
                    className={
                        className ||
                        'ads__unit ads__unit--native ads__unit--fullwidth'
                    }
                >
                    <NativeVideo
                        adObj={adObj}
                        mobile={getDeviceType() === 'mobile'}
                    />
                </div>
            );

        default:
            if (subvertical === 'holiday_rental') {
                defaultClassName = 'ads__unit ads__unit--native p-0 pb-16';
            }
            if (subvertical === 'flight') {
                defaultClassName = 'ads__unit ads__unit--native py-32';
            }
            if (subvertical === 'prepackage') {
                if (pageType === 'object') {
                    if (deviceType === 'mobile') {
                        defaultClassName = 'mx-0 my-16';
                    } else {
                        defaultClassName = 'ads__unit ads__unit--native p-0';
                    }
                } else {
                    defaultClassName = 'ads__unit ads__unit--native p-2';
                }
            }

            return (
                <div id={`${id}`} className={className || defaultClassName}>
                    <Netboard
                        adObj={adObj}
                        grid={grid}
                        vertical={vertical}
                        subvertical={subvertical}
                        pageType={pageType}
                        deviceType={deviceType}
                    />
                </div>
            );
    }
}
